<template>
  <div class="card-icon-rectangle card-component" @click="handleClick">
    <div class="w-2/5 flex justify-center">
      <i class="icon-cinergia flex justify-end pl-2" :class="[icon]"></i>
    </div>
    <p class="w-3/5 ml-6">
      {{ title }}
    </p>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "../../../store/wizard/types";
export default {
  props: {
    title: String,
    icon: String,
  },
  computed: {
    ...mapGetters({
      consult: GETTERS.GET_CONSULT,
    }),
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      setConsult: MUTATIONS.SET_CONSULT,
    }),
    handleClick() {
      //Set selected cardIconRectangle
      this.setConsult({
        ...this.consult,
        setpoint: this.title,
      });
    },
  },
};
</script>
